import React, { useState } from 'react';
import { EmptyPage } from '../EmptyPage';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from '../../components/Select';
import { Input } from '../../components/Input';
import { updateSettings } from '../../redux/settingSlice';
import { Button } from '../../components/Button';

export const Other = ({isSystemAccount}) => {
    
    const saveProfileSettings = () => {}
    const orderTypes = [
        {key: 'not-accepted', label: 'Не назначена'}, {key: 'process', label: 'В процессе'},
        {key: 'cancel', label: 'Отмена'}, {key: 'done', label: 'Готова'},
        {key: 'modern', label: 'Модерн'}, {key: 'warranty', label: 'Гарантия'}
    ]
    const dispatch = useDispatch();

    return (
        <div className='other-settings-page page'>
            <div className="other-settings">
                <h2>Другие настройки</h2>
                {/* <div className="other-settings__order-colors">
                    <h4>Цвета заявок</h4>
                    <div className="order-colors">
                        {orderTypes.map(ot => <div className="order-color">
                            <div><input type="color" /></div>
                            <div>{ot.label}</div>
                        </div>)}
                    </div>
                    <div className="other-settings__save">
                        <Button disabled={false} text={true ? 'Сохранить профильные настройки' : 'Нет изменений для сохранения'} onClick={saveProfileSettings}/>
                    </div>
                </div> */}
            </div>
        </div>
    );
};
